<template>
  <div class="tab-content" v-show="tabId == selectedId">
    <slot></slot>
  </div>
</template>

<script>
import { inject } from "vue";
export default {
  props: ["title", "tabId"],
  setup() {
    const selectedId = inject("selectedId");

    return {
      selectedId,
    };
  },
};
</script>

<style>
</style>